import { ReferralsTableFilters } from './components/ReferralsTable'

export const REFERRALS_TABLE_PAGE_SIZE = 12

export type ReferralsTab = 'sent' | 'received'

export const REFERRALS_TABLE_FILTERS: Record<
  keyof ReferralsTableFilters,
  keyof ReferralsTableFilters
> = {
  referralDate: 'referralDate',
  referredBy: 'referredBy',
  clientName: 'clientName',
  clientEmail: 'clientEmail',
  clientTelephone: 'clientTelephone',
  networks: 'networks',
  firm: 'firm',
  introducedTo: 'introducedTo',
  otherFirm: 'otherFirm',
  status: 'status',
  dateConsented: 'dateConsented',
  activities: 'activities',
  clientId: 'clientId',
  justification: 'justification',
  referralLinkCode: 'referralLinkCode',
  initialClientMeetingStartTime: 'initialClientMeetingStartTime',
  isEra: 'isEra',
  exemptActivityReason: 'exemptActivityReason',
  reason: 'reason',
  source: 'source',
}
